type AddSvgProps = {
  className?: string;
};

export const AddSvg = ({
  className = 'fill-ock-foreground-inverse',
}: AddSvgProps) => (
  <svg
    data-testid="ock-addSvg"
    role="img"
    aria-label="ock-addSvg"
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Add</title>
    <path
      d="M7.125 0H5.875V5.37501L0.5 5.37501L0.5 6.62501H5.875V12H7.125V6.62501H12.5V5.37501H7.125V0Z"
      className={className}
    />
  </svg>
);
